export default __webpack_public_path__ + "static/2-3f801f689bc18276d7c0dda2fab2c483.jpg";